/**
 * Visual properties of the Payment Request modal (also shared with the Merge modal).
 *
 * NOTE: Forcing the modal dialog's height ensures there is enough space for search results. This is a stopgap
 * solution until we have some better UI solutions.
 */
export const ModalAppearanceProps = Object.freeze({
    width: 590,
});
